/**
 * PostHog Early Setup
 *
 * Sets up API credentials and stubs PostHog before the main app initializes.
 * This runs early to capture events that happen before PostHog is fully initialized.
 */
import {
  setupAPICredentials,
  stubPostHog
} from '@/shared/pinia/modules/posthog/sdk';

setupAPICredentials();
stubPostHog();
